import ProcessScheduleModel from "@/models/lab/ProcessScheduleModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class ProcessScheduleCollection extends LabServiceCollection {
  model() {
    return ProcessScheduleModel;
  }
}
